import React from 'react';
import { FadeUp, ScalePop } from '../../../components/shared/Motion';
import { EditableText, EditableImage } from '../../components';

function AlumniPlaceholder({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  return (
    <section id="alumni" className="relative py-24 bg-olive-light overflow-hidden">
      <div className="container-page text-center">
        <FadeUp>
          <span className="eyebrow justify-center"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading_prefix} onChange={(t) => update({ heading_prefix: t })} as="span" />
            <span className="text-gradient"><EditableText value={data.heading_highlight} onChange={(t) => update({ heading_highlight: t })} as="span" /></span>
            <EditableText value={data.heading_suffix} onChange={(t) => update({ heading_suffix: t })} as="span" />
          </h2>
          <p className="section-lead mx-auto mt-4">
            <EditableText value={data.subheading} onChange={(t) => update({ subheading: t })} as="span" multiline />
          </p>
          <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-6">
            {items.map((a, i) => (
              <ScalePop key={i} delay={i * 0.08}>
                <div className="bg-white rounded-2xl p-6 border border-olive/10 hover:border-accent/40 hover:-translate-y-1 hover:shadow-glow-olive transition-all duration-300">
                  <div className="h-20 w-20 mx-auto rounded-full overflow-hidden ring-2 ring-accent/40">
                    <EditableImage
                      src={a.image?.src}
                      alt={a.image?.alt || a.name}
                      onChange={(src, alt) => updateItem(i, { image: { src, alt } })}
                      className="h-full w-full object-cover"
                    />
                  </div>
                  <EditableText value={a.name} onChange={(t) => updateItem(i, { name: t })} as="div" className="mt-4 font-bold text-olive-deep" />
                  <EditableText value={a.batch} onChange={(t) => updateItem(i, { batch: t })} as="div" className="text-xs text-ink/55 mt-1" />
                </div>
              </ScalePop>
            ))}
          </div>
        </FadeUp>
      </div>
    </section>
  );
}

export default AlumniPlaceholder;
